import React, { useState } from "react"
import { VariantReader } from "aldoo-ra/VariantReader"
import Typography from "aldoo-ra/Typography"
import { twMerge } from "tailwind-merge"
import { url } from "aldoo-ra/CMS/url"

export default function Avatar({
  user,
  variant = "default",
  styleOverrides,
  className = "",
  textVariant = "admin_label",
  textSize = "",
  alt,
  ...props
}) {
  const [imageError, setImageError] = useState(false)
  const [imageLoaded, setImageLoaded] = useState(false)

  const variants = VariantReader.useVariant({
    componentName: "Avatar",
    variant,
    styleOverrides,
  })

  // Generate initials from user data
  const initials = (user?.name || user?.email || user?.displayName || "U")
    .charAt(0)
    .toUpperCase()

  // Generate alt text
  const altText = alt || user?.name || user?.email || user?.displayName || "User avatar"

  return (
    <div className={twMerge(variants, className)} {...props}>
      {user?.avatar && !imageError && (
        <img
          src={url(user.avatar)}
          alt={altText}
          className={twMerge(variants, "object-cover")}
          data-user-avatar={user._id || user.id}
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageError(true)}
          style={{ display: imageLoaded ? 'block' : 'none' }}
        />
      )}
      {(!user?.avatar || imageError || !imageLoaded) && (
        <Typography
          variant={textVariant}
          className={twMerge("text-white my-0", textSize)}
        >
          {initials}
        </Typography>
      )}
    </div>
  )
}